import { Component, effect, forwardRef, inject, input, signal } from '@angular/core';
import { LpCanvasComponentsComponent } from '@features/lp/lp-canvas/lp-canvas-components/lp-canvas-components.component';
import { ILpCanvasElementContext } from '@features/lp/lp-canvas/lp-canvas.types';
import { LpConditionsService } from '@features/lp/lp-conditions/lp-conditions.service';
import { LpCanvasElementComponent, LpIfCanvasComponent } from '@typings/lp/generated';

@Component({
  selector: 'lp-if-canvas-component',
  imports: [forwardRef(() => LpCanvasComponentsComponent)],
  templateUrl: './lp-if-canvas-component.component.html',
  styleUrl: './lp-if-canvas-component.component.css',
})
export class LpIfCanvasComponentComponent {
  readonly #lpConditionsService = inject(LpConditionsService);

  comp = input.required<LpIfCanvasComponent>();
  context = input.required<ILpCanvasElementContext>();

  components = signal<LpCanvasElementComponent[]>([]);

  constructor() {
    effect(async () => {
      this.#lpConditionsService.subscribe();

      const satisfied = await this.#lpConditionsService.evaluate(this.comp().if);
      if (satisfied) {
        this.components.set(this.comp().components);
      } else {
        this.components.set(
          (
            await Promise.all(
              this.comp().elses.map(async (els) => {
                const satisfied = await this.#lpConditionsService.evaluate(els.else);
                if (satisfied) return els.components;
                else return [];
              }),
            )
          ).flat(),
        );
      }
    });
  }
}
